import { PanelGroup } from '@creditflowresearch/uilib/PanelGroup';
import { TranchePanel } from '@/creditflowresearch/ui/components/deals/DealListTable/components/TrancheList/components/TranchePanel';
import type ITranch from '@/creditflowresearch/domain/vo/Tranch/ITranch';

export const TrancheList = ({ tranches }: { tranches: ITranch[] }) => (
  <PanelGroup
    expandBy={ tranches.map((tranche) => tranche.id) }
    dataTest="trancheListPanelGroup"
  >
    { tranches.map((tranche, index) => (
      <TranchePanel
        key={ tranche.id }
        index={ index }
        tranche={ tranche }
      />
    )) }
  </PanelGroup>
);
